module.exports = __webpack_public_path__ + "img/hero-image.68718083.png";